
export const getConvocationInfos = async (dossierValue, index) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    }
  };

  try {
    const response = await fetch(`/api/cissct/getConvocation/${dossierValue}/${index}`, requestOptions);
    if (!response.ok) {
      return [];
    }
    
    const data = await response.json();
    const parsed = await JSON.parse(data.data);
    
    return parsed;
  } catch (err) {
    console.error("Erreur lors de la récupération des infos du dossier:", err);
    throw err;
  }
}